var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAthletes(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "123px",
    height: "131px",
    viewBox: "0 0 123 131",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "BTI_Group 5") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Website",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop_Research",
    transform: "translate(-148.000000, -844.000000)",
    stroke: "#006AF9",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(150.000000, 846.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.5,13.9998575 C75.5,21.7318496 81.7678653,28 89.4998575,28 C97.2318496,28 103.5,21.7318496 103.5,13.9998575 C103.5,6.26786532 97.2318496,0 89.4998575,0 C81.7678653,0 75.5,6.26786532 75.5,13.9998575 Z",
    id: "Stroke-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.044345,59.6387787 L101.497763,59.6387787 L87.2870736,39.3170786 C87.2870736,39.3170786 82.9734155,32.3715846 73.8377159,32.1143337 C64.7022926,31.8570828 41.609681,32.1143337 41.609681,32.1143337 C41.609681,32.1143337 36.2803616,31.5998319 31.9667035,38.0308242 C29.5826362,41.5846977 26.5010964,46.2384729 24.2209726,49.6909033 C22.568104,52.1941955 23.2863098,55.5863765 25.8063885,57.1828453 C27.9839509,58.5626965 31.6059419,58.2421137 33.0957076,56.1216152 L42.1172352,43.1755619 L57.0892556,43.1755619 L37.0416929,74.3015194 L24.6074437,91.279238 L7.73209487,91.279238 C3.738008,91.279238 0.5,94.5615689 0.5,98.6103281 C0.5,103.36975 3.54449604,105.427197 8.2396491,105.427197 L26.291827,106.4562 C29.418151,106.4562 32.3963001,105.105213 34.4793181,102.742035 L52.2674905,82.2757368 L64.7022926,97.70995 L58.2757604,116.854125 C56.7613911,120.819656 57.5851991,124.775659 61.4297289,126.476373 C65.3544279,128.212396 68.65823,125.400291 70.4230591,121.445409 L79.428,101.267466 C80.8326204,98.1196458 80.4414497,94.4472351 78.4065333,91.6760433 L66.9862867,74.5584901 L79.4205359,53.7222882 L90.2173976,67.6135565 C91.7320433,69.5625543 94.0447877,70.7000068 96.492714,70.7000068 L113.044345,70.7000068 C116.057326,70.7000068 118.5,68.2238969 118.5,65.1693927 C118.5,62.1148886 116.057326,59.6387787 113.044345,59.6387787 Z",
    id: "Stroke-3"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAthletes);
export default __webpack_public_path__ + "static/media/Athletes.059b61a1cde727191d0389ad7562ec21.svg";
export { ForwardRef as ReactComponent };